angular.module('invoice')
    .controller('InvoiceBgtEditController', function (data, $uibModalInstance, Invoice, InvoiceService, BgtGroupingService) {
        this.InvoiceService = InvoiceService

        this.$onInit = () => {
            this.items = angular.copy(data.items)
            this.processGrouped()

            Invoice.get({id: data.id}).$promise.then(item => {
                this.totalNet = item.pricing.totalNet;
            })
        }
        this.getTotal = () => {
            return BgtGroupingService.sumAmounts(this.items);
        }

        this.add = (group) => {
            if(group == null || this.items.some(item => item.group.id === group.id)) {
                return;
            }
            let amount = this.totalNet - this.getTotal();
            let item = { group: group, amount: amount };
            this.onAmountChanged(item);
            this.items.push(item);
            this.processGrouped()
        };
        this.delete = (item) => {
            const index = this.items.indexOf(item);
            if (index > -1) {
                this.items.splice(index, 1);
            }
            this.processGrouped()
        };

        this.onPercentageChanged = (c) => {
            c.amount = InvoiceService.multiply(c.percentage / 100, this.totalNet)
        }
        this.onAmountChanged = (c) => {
            c.percentage = InvoiceService.percentage(c.amount, this.totalNet) || 0
        }

        this.getGroupTotal = (grouped) => {
            return BgtGroupingService.sumGroupAmounts(grouped);
        }

        this.processGrouped = () => {
            this.groupedItems = BgtGroupingService.groupItemsByParent(this.items);
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            $uibModalInstance.close(this.items)
        }
    })
